import { render, staticRenderFns } from "./CoachSelectDialog.vue?vue&type=template&id=69520be2&scoped=true&"
import script from "./CoachSelectDialog.vue?vue&type=script&lang=js&"
export * from "./CoachSelectDialog.vue?vue&type=script&lang=js&"
import style0 from "./CoachSelectDialog.vue?vue&type=style&index=0&id=69520be2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69520be2",
  null
  
)

export default component.exports